import { FilterFieldType, IFilter } from './types'

export const DILUTION_BY_CUSTOMER_LIST_FILTERS_CONFIG = [
  {
    field: 'debtor',
    type: FilterFieldType.List,
    isMultiple: true,
    title: 'Customer',
    align: 'left',
    isSortable: true,
  },
  {
    field: 'invoices',
    type: FilterFieldType.Amount,
    title: 'Invoices',
    isSortable: true,
  },
  {
    field: 'payments',
    type: FilterFieldType.Amount,
    title: 'Payments',
    isSortable: true,
  },
  {
    field: 'dilutiveCredits',
    type: FilterFieldType.Amount,
    title: 'Dilutive Credits',
    isSortable: true,
  },
  {
    field: 'other',
    type: FilterFieldType.Amount,
    title: 'Other',
    isSortable: true,
  },
  {
    field: 'dilution',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: 'Dilution',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'category',
        type: FilterFieldType.List,
        isMultiple: true,
      },
    ],
    quickFilters: [],
  },
] as const satisfies IFilter[]

export const DILUTION_OVER_TIME_LIST_FILTERS_CONFIG = [
  {
    field: 'debtor',
    type: FilterFieldType.List,
    isMultiple: true,
    title: 'Customer',
    align: 'left',
    isSortable: true,
  },
  {
    field: 'invoices',
    type: FilterFieldType.Amount,
    title: 'Invoices',
    isSortable: true,
  },
  {
    field: 'payments',
    type: FilterFieldType.Amount,
    title: 'Payments',
    isSortable: true,
  },
  {
    field: 'dilutiveCredits',
    type: FilterFieldType.Amount,
    title: 'Dilutive Credits',
    isSortable: true,
  },
  {
    field: 'other',
    type: FilterFieldType.Amount,
    title: 'Other',
    isSortable: true,
  },
  {
    field: 'dilution',
    type: FilterFieldType.Percent,
    title: 'Dilution',
    isSortable: true,
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'category',
        type: FilterFieldType.List,
        isMultiple: true,
      },
    ],
    quickFilters: [],
  },
] as const satisfies IFilter[]
